import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "on",
  "use": "on-usage",
  "viewBox": "0 0 19.75 26.33",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19.75 26.33\" id=\"on\"><title>资源 14</title><g data-name=\"图层 2\"><path d=\"M14 20.08A7.79 7.79 0 0 0 9.8 5.7h-.22a7.79 7.79 0 0 0-3.94 14.38.47.47 0 0 1 .22.39v1h-1.5a.88.88 0 1 0 0 1.76h10.88a.88.88 0 1 0 0-1.76h-1.5v-1a.47.47 0 0 1 .26-.39zM3.17 7.66a.88.88 0 0 0 0-1.25L1.5 4.75A.88.88 0 0 0 .26 6l1.66 1.66a.88.88 0 0 0 .62.26.87.87 0 0 0 .63-.26zM9.8 4.11a.88.88 0 0 0 .88-.88V.88a.88.88 0 0 0-1.76 0v2.35a.88.88 0 0 0 .88.88zm4.08 20.46H5.72a.88.88 0 0 0 0 1.76h8.16a.88.88 0 1 0 0-1.76zm5.61-19.84a.88.88 0 0 0-1.25 0l-1.66 1.66a.88.88 0 0 0 .62 1.5.87.87 0 0 0 .62-.26L19.49 6a.88.88 0 0 0 0-1.27z\" data-name=\"图层 1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/on.svg
// module id = MFTv
// module chunks = 6